import { FileType } from './file-type.enum';

export enum FileTypeExtension {
  Csv = '.csv',
  Jpg = '.jpg',
  Png = '.png',
  Gif = '.gif',
  Mp4 = '.mp4',
  Mp3 = '.mp3',
  Svg = '.svg',
  Xlsx = '.xlsx'
}

export const FileTypeTexts: Record<FileType, FileTypeExtension> = {
  [FileType.ImagePng]: FileTypeExtension.Png,
  [FileType.ImageGif]: FileTypeExtension.Gif,
  [FileType.ImageSvg]: FileTypeExtension.Svg,
  [FileType.ImageJpeg]: FileTypeExtension.Jpg,
  [FileType.VideoMp4]: FileTypeExtension.Mp4,
  [FileType.AudioMp3]: FileTypeExtension.Mp3,
  [FileType.TextCsv]: FileTypeExtension.Csv,
  [FileType.ExcelXlsx]: FileTypeExtension.Xlsx
};
